module.exports = __webpack_public_path__ + "img/vertical_5_1_3009.244dac67.png";